// extracted by mini-css-extract-plugin
export default {"root":"_1mW1HQX1","container":"_3FNjZsPb","mobileBackButton":"_2w_-PAl7","sidebar":"_3TOoUO7D"};